import styles from "../ProductDetailsComp/ProductDetails.module.scss";

export default function MTOMessage({
  estimatedDate,
  shippingLeadTime,
  engravingAdded,
  isDrawer = false,
}) {
  let isAdditionalLeadTime = shippingLeadTime && shippingLeadTime.value > 0;
  return (
    <div className={styles.mto_wrapper}>
      <p
        className={`x-small italic info_msg ${styles.info_msg} ${
          isDrawer ? styles.drawer : ""
        }`}
      >
        <img className="" alt="info" src="/icons/info.svg" />
        <span>
          Made to order - This item is final sale and cannot be returned.{" "}
          {estimatedDate?.split("delivery")[1] && (
            <span
              className={`x-small ${
                isAdditionalLeadTime &&
                (isDrawer ? true : engravingAdded) &&
                "bold"
              }`}
            >
              {isAdditionalLeadTime &&
                (isDrawer ? true : engravingAdded) &&
                "New"}{" "}
              Estimated delivery: {estimatedDate?.split("delivery")[1]}
            </span>
          )}
        </span>
      </p>
    </div>
  );
}
